<div class="session-expired">
    <dr-card [padding]="'none'" [appearance]="'outlined'" class="session-expired__card">
        <div class="session-expired__content">
            <h1 class="session-expired__title">Your session has expired</h1>
            <p class="session-expired__subtitle">
                You've been inactive for a while, so we cleared your progress for security. Pick up where this started
                by setting things up again — it only takes a couple of minutes.
            </p>
            <div class="session-expired__actions">
                <dr-button [theme]="'primary'" [type]="'button'" (click)="openUpgradeDialog()">
                    Unlock full version
                </dr-button>
                <dr-button [theme]="'ghost'" [type]="'button'" (click)="handleRestart()"> Start over </dr-button>
            </div>
        </div>
    </dr-card>
</div>
